import {Component, EventEmitter, HostBinding, Input, OnInit, Output} from '@angular/core';
import {IonButtonBaseComponent} from 'app/core/ion-components/ionButton';
import {AppColorList, ButtonColors, ButtonSize} from 'app/entities/enums';

@Component({
  selector: 'app-button',
  templateUrl: 'item.html',
  styleUrls: ['item.scss']
})

/**
 * Usage:
 * ```
 *           <app-button
 *             mode="secondary"
 *             buttonText="Button with Icon disabled"
 *             iconUrl="/assets/icons/alert.svg"
 *             color="alert"
 *             smallSize="true"
 *             disabled="true"
 *           ></app-button>
 * ```
 *
 * Configurable params:
 *  - mode
 *  - buttonText   - if (mode == 'round'), then `buttonText` always empty
 *  - iconUrl
 *  - color        - if (mode in ['secondary', 'ghost']), then `color` always 'default'
 *  - smallSize    - if (mode == 'ghost'), then `smallSize` always false
 *  - disabled
 *  - clickButton  - `(click)` event emitter
 *
 *  All parameters optional -> button has default setup
 */
export class ButtonComponent extends IonButtonBaseComponent implements OnInit {

  @Input() icon: any /*'values' | 'users' | 'trash-bin' | 'settings' | 'search' | 'profile' | 'plus-sign' | 'plus' | 'persacc' | 'notices' | 'more' | 'messages' | 'lock' | 'fines' | 'exit' | 'edit-pencil' | 'dash' | 'cancel-cross-input' | 'cancel-cross' | 'calend' | 'alert' | 'back-gray' | 'settings-gray'*/;
  @Input() color: AppColorList = 'primary';
  @Input() size: ButtonSize = 'large';
  @Input() buttonFontSize: ButtonSize = 'large';
  @Input() loading = false;
  @Input() notification = -1;   // (== 0)  - show notification dot; (> 0)  - show notification bubble with notification number

  @Output() clickButton: EventEmitter<void> = new EventEmitter();

  ngOnInit() {
    this.ionColor = 'default';
  }

  getIconUrl() {
    return this.icon ? `/assets/icons/${this.icon}.svg` : null;
  }

  @HostBinding('class')
  get classes() {
    return {
      [`button-shape-${this.shape}`]: this.shape,
      [`button-color-${this.color}`]: this.color,
      [`button-size-${this.size}`]: this.size,
      [`button-font-size-${this.buttonFontSize}`]: this.buttonFontSize,
      [`button-expand-${this.expand}`]: this.expand,
      [`button-loading`]: this.loading,
      'show-notification': this.notification === 0
    };
  }

  onClick() {
    this.clickButton.emit();
  }

}
